import baseURL from '@/config/index'

/**
 * 存放所有的接口地址
 */
const defaultBaseAction = "wap/"
const commonAction = "common/"
const uploadAction = commonAction + "file/"
const areaAction = commonAction + "area/"
const dictAction = commonAction + "dict/"
const studentAction = "student/"
const teacherAction = "teacher/"
//const wechatAction = "wechat"
export default {
  //项目
  project: {
    list: defaultBaseAction + "projects",
    url: defaultBaseAction + "project",
    //项目进展
    progresses: {
      list: defaultBaseAction + "project_progresses",
      url: defaultBaseAction + "project_progress"
    },
    cate: {
      list: defaultBaseAction + "project_types",
      url: defaultBaseAction + "project_type"
    }
  },
  //活动
  activity: {
    list: defaultBaseAction + "activities",
    url: defaultBaseAction + "activity",
    detail: defaultBaseAction + "activity_detail",
    user: defaultBaseAction + "activities_user",
    type: {
      list: defaultBaseAction + "activity_types"
    },
    //活动模板消息
    template: {
      url: defaultBaseAction + "activity_message_template"
    },
    share: {
      url: defaultBaseAction + "activity_share"
    },
    //活动报名
    apply: {
      list: defaultBaseAction + "activity_applys",
      url: defaultBaseAction + "activity_apply",
      user: defaultBaseAction + "activity_applys_user",
      viewList: defaultBaseAction + "view_activity_applys",
    },
    checkApply: defaultBaseAction + "check_activity_apply",
    //查看走访的申请对象列表
    activity_group: defaultBaseAction + "volunteer_activity_group",
    //走访记录
    visit: {
      list: defaultBaseAction + "visit_records",
      url: defaultBaseAction + "visit_record",
      edit: defaultBaseAction + "visit_record_edit"
    },
    custom: {
      url: defaultBaseAction + "activity_custom"
    }
  },
  //新闻模块
  news: {
    list: defaultBaseAction + "news_list",
    url: defaultBaseAction + "news",
    cate: {
      list: defaultBaseAction + "news_categorys",
      url: defaultBaseAction + "news_category"
    },
    association: defaultBaseAction + "association_list"
  },
  application_set: {
    list: defaultBaseAction + "student_application_sets",
    url: defaultBaseAction + "student_application_set",
    field: defaultBaseAction + "student_application_set_field"
  },
  studentApplication: {
    list: defaultBaseAction + "student_application_list",
    audit: defaultBaseAction + "student_application_audit",
    field: defaultBaseAction + "student_application_field",
    url: defaultBaseAction + "student_application_info",
    auditList: defaultBaseAction + "student_application_audits",
    type: defaultBaseAction + "student_application_by_type"
  },
  //前端资助信息变更
  support: {
    url: defaultBaseAction + "support_apply_change",
    apply: {
      url: defaultBaseAction + "support_apply"
    },
    taizhang: teacherAction + "student_accounts_school_list",
    mingxi: teacherAction + "student_financial_aids",
    studentExport: teacherAction + "student_export",
    schools: teacherAction + "schools"
  },
  application: {
    list: defaultBaseAction + "support_applys",
    url: defaultBaseAction + "support_apply",
    user: {
      export: teacherAction + "support_user_export"
    }
  },
  //勋章
  medals: {
    list: defaultBaseAction + "volunteer_medals_high_light",//高亮显示
    url: defaultBaseAction + "medal",
    volunteer: defaultBaseAction + "volunteer_medals"

  },
  //新闻
  document: {
    list: "news-getNewsList",
    cate: {
      list: "news-getNewsCateList"
    }
  },
  //志愿者
  volunteer: {
    url: defaultBaseAction + "volunteer",//已经注册过用户，直接注册志愿者
    add: defaultBaseAction + "volunteer_user",//注册用户并成为志愿者
    //志愿者技能
    skill: {
      list: defaultBaseAction + "pub_skills"
    },
    //业务区域
    regions: {
      list: defaultBaseAction + "business_regions",
      url: defaultBaseAction + "business_region"
    },
    //志愿者统计总数、总服务时长
    statistics: defaultBaseAction + "volunteer_statistics",
    //志愿者排名
    ranking: defaultBaseAction + "volunteer_ranking",
  },
  //用户
  user: {
    list: defaultBaseAction + "users",
    url: defaultBaseAction + "user",
    info: defaultBaseAction + "user_center",
    support: {
      list: teacherAction + "support_users",
      ab: teacherAction + "ab_support_user",
      url: teacherAction + "support_user",
      ed: teacherAction + "ed_support_user",
      moneys: teacherAction + "support_moneys"
    },
    //老师信息
    teacher: {
      url: defaultBaseAction + "teacher"
    }
  },
  //年度工作计划
  yearPlanConfig: {
    list: defaultBaseAction + "year_plan_configs",
    url: defaultBaseAction + "year_plan_config"
  },
  public: {
    token: "getToken"
  },
  upload: {
    uploadFile: baseURL + uploadAction + "upload_file",//文件上传
    uploadBase64File: uploadAction + "upload_base64",//base64图片上传
    uploadActivityBase64: uploadAction + "upload_activity_base64",
    uploadPic: baseURL + uploadAction + "upload_pic",//图片上传
    uploadEditor: baseURL + uploadAction + "editor",//富文本图片上传
  },
  area: {
    list: areaAction + "list"
  },
  //微信模板
  wechatTpl: {
    list: defaultBaseAction + "message_template_wechats",
    url: defaultBaseAction + "message_template_wechat"
  },
  //系统字典值
  dict: {
    list: baseURL + dictAction + "list_with_type",
    //民族列表
    nations: dictAction + "nations",
    lists: baseURL + dictAction + "list"
  },
  //token认证
  token: {
    add: commonAction + "create_token"
  },
  //发送相关
  send: {
    //发送短信验证码
    SmsCode: commonAction + "sendSms",
    checkSmsCode: commonAction + "checkSms",
    captcha: commonAction + "captcha",
    login:commonAction+"login"
  },
  wechat: {
    oauth: commonAction + "get_oauth_user_info",
    jssign: commonAction + "get_js_sign"
  },
  //反哺计划
  college: {
    //反哺大学生信息
    student: {
      list: defaultBaseAction + "college_students",
      url: defaultBaseAction + "college_student",
    },
    //反哺大学生登记信息
    studentApply: {
      list: studentAction + "college_student_applys",
      url: studentAction + "college_student_apply",
      audit: studentAction + "audit_college_student_applys",
      auditList: studentAction + "college_student_applys_audit"
    },
    //反哺计划奖助学金申请
    support: {
      list: defaultBaseAction + "college_support_applys",
      url: defaultBaseAction + "college_support_apply",
      audit: defaultBaseAction + "audit_college_support_applys",
      auditList: defaultBaseAction + "college_support_applys_audit",
      //反哺大学生奖学金导出Excel
      export: defaultBaseAction + "college_support_apply/export",
      //反哺大学生奖学金导出压缩包
      exportFile: defaultBaseAction + "college_support_apply_file/export"
    }
  },
  school: {
    list: defaultBaseAction + "schools",
    url: defaultBaseAction + "school"
  },
  //极验
  geetest: {
    register: commonAction + "register_gee_test",//注册行为校验
    validate: commonAction + "validate_gee_test",//校验行为验证
  },
  imports: {
    //资助对象信息导入
    supportInfo: baseURL + defaultBaseAction + "import_support_info",
    supportApplyBank: baseURL + commonAction + "import_support_apply_bank"
  },
  //获取地图经纬度
  maps: {
    list: commonAction + "maps"
  },
  statistics: {
    index_data: commonAction + "statistics_index_all_data",
    subsidize_data: commonAction + "statistics_subsidize_data",//资助数据统计
    activity_apply_data: commonAction + "statistics_activity_apply_data",//按月份统计活动报名人数
    activity_apply_join_data: commonAction + "statistics_activity_apply_join_data",//按月份统计活动报名人数
    activity_apply_join_list: commonAction + "statistics_activity_apply_join_list",
    activity_data: commonAction + "statistics_activity_data",
    user_info_data: commonAction + "statistics_user_info_data",
    area_activity_data: commonAction + "area_activity_data",
    area_student_data: commonAction + "area_student_data",
    area_support_user_data: commonAction + "area_support_user_data"
  },
  website: {
    channel: {
      list: defaultBaseAction + "website_channels",
      url: defaultBaseAction + "website_channel"
    },
    ads: {
      list: defaultBaseAction + "website_ads_list",
      url: defaultBaseAction + "website_ads"
    },
    list: defaultBaseAction + "website_infos"
  },
  pageIndex: {
    url: defaultBaseAction + "page_index",
    list: defaultBaseAction + "page_indexs"
  },
  cooperator: {
    list: defaultBaseAction + "cooperators"
  },
  // 赋能课程
  column: {
    applyList: defaultBaseAction + 'view_column_applys'
  }
}



// WEBPACK FOOTER //
// ./src/config/url.js